import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "@environments/environment";
import { BurolarInfo } from "@models/genel/BurolarInfo";
import { SayfalamaSonuc } from "@models_genel/SayfalamaSonuc";
import { HashingHelperService } from "@core/utils/hashing.helper.service";

@Injectable()
export class VeriAlGonderService {
	constructor(
		private http: HttpClient,
		private hashingHelper: HashingHelperService
	) {}
	
	urunleriAktar(parametersModel: any): Observable<any> {
		return this.http.post<BurolarInfo>(environment.VERI_AKTARIM_URL + "AddUrunAktarFromOnMuhasebe", parametersModel);
	}
	
	getAktarilacakUrunler(parametersModel?: any): Observable<SayfalamaSonuc> {
		return this.http.post<SayfalamaSonuc>(environment.VERI_AKTARIM_URL + "GetAktarilacakUrunlerFromOnMuhasebe", parametersModel);
	}


	carileriAktar(parametersModel: any): Observable<any> {
		return this.http.post<BurolarInfo>(environment.VERI_AKTARIM_URL + "AddCariAktarFromOnMuhasebe", parametersModel);
	}
	
	getAktarilacakCariler(parametersModel?: any): Observable<SayfalamaSonuc> {
		return this.http.post<SayfalamaSonuc>(environment.VERI_AKTARIM_URL + "GetAktarilacakCarilerFromOnMuhasebe", parametersModel);
	}
	
	getAktarilacakBankaHesaplari(parametersModel?: any): Observable<SayfalamaSonuc> {
		return this.http.post<SayfalamaSonuc>(environment.VERI_AKTARIM_URL + "GetAktarilacakBankaHesaplariFromOnMuhasebe", parametersModel);
	}

	bankaHesaplariniAktar(parametersModel: any): Observable<any> {
		return this.http.post<BurolarInfo>(environment.VERI_AKTARIM_URL + "AddBankaHesapAktarFromOnMuhasebe", parametersModel);
	}
}
